/**
 * Composition Time to Sample Entry
 *
 * @group ISOBMFF
 *
 * @beta
 */
export type CompTimeToSampleEntry = {
	sampleCount: number;
	sampleOffset: number;
};
